import React from 'react';
import {connect} from "react-redux";

import {
    fetchModules,
    fetchStores,
    selectModule,
    selectStore
} from './reducer';

import ModuleSelector from '../../components/ModuleSelector';
import StoreSelector from './StoreSelector';
import AssignmentPanel from './AssignmentPanel';


export class AreaControlAdminManager extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.state = {};
        this.renderAssignmentPanel = this.renderAssignmentPanel.bind(this);
    }

    componentDidMount() {
        this.props.fetchModules();
        this.props.fetchStores();
    }

    renderAssignmentPanel() {
        const moduleSelected = this.props.selectedModule && this.props.selectedModule !== '';
        const storeSelected = this.props.selectedStore && this.props.selectedStore !== '';
        if(!moduleSelected || !storeSelected) {
            return null;
        }

        return <AssignmentPanel/>;
    }

    render() {

        return (
            <div className="animated fadeIn">
                <div className="card">
                    <div className="card-body">
                        <h4 className="card-title">Flächensteuerung verwalten</h4>
                        <ModuleSelector modules={this.props.modules}
                                        selectedModule={this.props.selectedModule}
                                        selectModule={this.props.selectModule}/>
                        <StoreSelector stores={this.props.stores}
                                       selectedStore={this.props.selectedStore}
                                       selectStore={this.props.selectStore}
                                       selectedModule={this.props.selectedModule}/>
                        <div className="row">
                            <div className="col-lg-12">
                                <hr style={{borderTop: '2px solid #c2cfd6'}}/>
                            </div>
                        </div>
                        {this.renderAssignmentPanel()}
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        modules: state.areacontrolAdmin.get('modules').toJS(),
        stores: state.areacontrolAdmin.get('stores').toJS(),
        selectedModule: state.areacontrolAdmin.get('selectedModule'),
        selectedStore: state.areacontrolAdmin.get('selectedStore')
    };
}

const ConnectedAreaControlAdminManager = connect(mapStateToProps, {
    fetchModules,
    fetchStores,
    selectModule,
    selectStore
})(AreaControlAdminManager);

export default ConnectedAreaControlAdminManager;



// WEBPACK FOOTER //
// ./src/admin/areacontrol/admin/AreaControlAdminManager.js